module.exports = __webpack_public_path__ + "static/media/promo.e70ee4b5.png";